import React from "react";

function Donate() {
  return (
   <div className="centered-page">
      <h2>Donate</h2>
      <p>
        Keeping all these athletes on the water requires significant resources. Your support helps us provide the best possible experience for our team.
      </p>
      <div style={{ margin: ".5rem 0", textAlign: "center" }}>
        <p>
          The Friends of Roosevelt High School Rowing is a 501(c)(3) nonprofit
          organization, and your contributions are tax-deductible. You can
          donate via Venmo or by mailing a check payable to FRHSR to our address
          below.
        </p>
        <a
          href="https://venmo.com/u/fwrhsr"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            background: "#3D95CE",
            color: "#fff",
            padding: "1rem 2rem",
            borderRadius: "8px",
            fontWeight: "bold",
            fontSize: "1.2rem",
            textDecoration: "none",
            marginBottom: "1.5rem",
          }}
        >
          Donate via Venmo @fwrhsr
        </a>
        <div style={{ marginTop: "2rem" }}>
          <img
            src="/VenmoRowing.png"
            alt="Scan with your phone or other device to donate via Venmo"
            style={{
              maxWidth: "300px",
              width: "100%",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          />
        </div>
        <div
          style={{
            margin: "1rem 0 0 0",
            padding: "1rem 0 0 0",
            background: "#f6f8fa",
            borderRadius: "10px",
            border: "1px solid #d1d5db",
            fontSize: "1.1rem",
            fontFamily: "inherit",
            color: "#162278",
            boxShadow: "0 2px 8px rgba(22,22,116,0.06)",
          }}
        >
          <strong>Friends of Roosevelt High School Rowing (FRHSR) </strong>
          <br />
          c/o Wyandotte Boat Club
          <br />
          1 Pine Street
          <br />
          Wyandotte, MI 48192
        </div>
      </div>
    </div>
  );
}

export default Donate;
